<div class="cups-dialog">
  <h1 class="title">{{ 'NEW_CONTRACTS.CUPS_DIALOG.TITLE' | i18nextEager }}</h1>
  <p class="text">{{ 'NEW_CONTRACTS.CUPS_DIALOG.TEXT' | i18nextEager }}</p>
  <table>
    <tr>
      <th>{{ 'NEW_CONTRACTS.CUPS_DIALOG.COUNTRY_CODE' | i18nextEager }}</th>
      <th>{{ 'NEW_CONTRACTS.CUPS_DIALOG.ID_DISTRIB' | i18nextEager }}</th>
      <th>{{ 'NEW_CONTRACTS.CUPS_DIALOG.NUMBER' | i18nextEager }}</th>
      <th>{{ 'NEW_CONTRACTS.CUPS_DIALOG.CONTROL' | i18nextEager }}</th>
    </tr>
    <tr>
      <td>{{ country }}</td>
      <td>1234</td>
      <td>123456789123</td>
      <td>XX</td>
    </tr>
  </table>

  <br />
  <div class="button">
    <button (click)="closeDialog()" class="primary">Ok</button>
  </div>
</div>
